/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    interface IIfContains extends ng.IDirective {

    }

    interface IIfContainsScope extends ng.IScope {
        element: any;
    }

    class IfContains  implements IIfContains {
        static directiveId: string = "ifContains";
        restrict: string = "A";
        scope: any = {};
        constructor() {
        }

        link = (scope: IIfContainsScope, element, attrs) => {
            scope.element = element;
            scope.$watch(() => {return element[0].innerHTML; },() => {
                if (element.find(attrs.ifContains).length <= 0) {
                    element.addClass("ng-hide");
                }
                else {
                    element.removeClass("ng-hide");
                }
            });  
        }

    }

    angular.module("app").directive(IfContains.directiveId, [() =>
        new IfContains()
    ]);

}